const libPictView = require('pict-view');
const libLayout = require('./PictView-Layout.js');
const libSig = require('./PictView-Signature.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'AgentDetail',
	DefaultRenderable: 'AgentDetail-Empty',
	CSS: /*css*/`
		.cst-ag-meta { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); margin-bottom: 10px; }
		.cst-ag-turn { margin-bottom: 12px; padding: 8px 10px; border-radius: 4px; font-size: 12px; line-height: 1.4; }
		.cst-ag-turn-user { background: #eef7f1; }
		.cst-ag-turn-assistant { background: var(--theme-color-background-secondary, #fafbfd); border: 1px solid var(--theme-color-border-default, #dde2ee); }
		.cst-ag-turn-toolresult { background: #fbfaff; border: 1px solid #e1ddee; }
		.cst-ag-turn-time { font-family: monospace; color: var(--theme-color-text-secondary, #5b6376); font-size: 11px; }
		.cst-ag-tool-chip
		{
			display: inline-block;
			margin: 2px 4px 2px 0;
			padding: 2px 6px;
			background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #dde2ee); border-left: 3px solid var(--theme-color-brand-accent, #b07acc);
			border-radius: 3px; font-size: 11px; font-family: monospace;
		}
		.cst-ag-text { white-space: pre-wrap; margin: 4px 0; }
	`,
	Templates:
	[
		{ Hash: 'AgentDetail-Empty', Template: '<span></span>' }
	],
	Renderables: []
};

class PictViewAgentDetail extends libPictView
{
	openAgent(pAgentId)
	{
		let tmpSession = this.pict.AppData.Session;
		if (!tmpSession || !tmpSession.Agents) return;
		let tmpAgent = tmpSession.Agents[pAgentId];
		if (!tmpAgent) return;

		let tmpHTML = '';
		tmpHTML += '<div class="cst-ag-meta">'
			+ '<strong>' + libLayout.escapeHTML(tmpAgent.AgentType) + '</strong> · '
			+ libLayout.formatDuration(tmpAgent.DurationMs) + ' · '
			+ tmpAgent.ToolCallCount + ' tool calls'
			+ '</div>';
		tmpHTML += '<div class="cst-ag-meta">' + libLayout.escapeHTML(tmpAgent.Description || '') + '</div>';

		for (let i = 0; i < tmpAgent.Turns.length; i++)
		{
			let tmpT = tmpAgent.Turns[i];
			let tmpClass = 'cst-ag-turn-' + (tmpT.Kind === 'user-prompt' ? 'user' : tmpT.Kind === 'assistant' ? 'assistant' : 'toolresult');
			let tmpTime = tmpT.TimestampMs ? '<span class="cst-ag-turn-time">' + new Date(tmpT.TimestampMs).toLocaleTimeString() + '</span> ' : '';
			let tmpBody = '';
			let tmpChips = '';
			for (let j = 0; j < tmpT.Blocks.length; j++)
			{
				let tmpB = tmpT.Blocks[j];
				if (tmpB.Type === 'text')        tmpBody += '<div class="cst-ag-text">' + libLayout.escapeHTML(tmpB.Text || '') + '</div>';
				else if (tmpB.Type === 'thinking') tmpBody += '<div class="cst-ag-text" style="font-style:italic;color:var(--theme-color-text-secondary, #5b6376);">' + libLayout.escapeHTML(tmpB.Text || '') + '</div>';
				else if (tmpB.Type === 'tool_use')
				{
					tmpChips += '<span class="cst-ag-tool-chip cst-tool-family-' + libSig.toolFamily(tmpB.Name) + '">'
						+ libLayout.escapeHTML(tmpB.Name) + (tmpB.InputSummary ? ': ' + libLayout.escapeHTML(tmpB.InputSummary) : '')
						+ '</span>';
				}
				else if (tmpB.Type === 'tool_result')
				{
					tmpBody += '<div class="cst-ag-text" style="font-family:monospace;font-size:10px;color:var(--theme-color-text-secondary, #5b6376);">'
						+ libLayout.escapeHTML((tmpB.ContentText || '').slice(0, 600))
						+ (tmpB.ContentTruncated || (tmpB.ContentText || '').length > 600 ? ' …' : '')
						+ '</div>';
				}
			}
			tmpHTML += '<div class="cst-ag-turn ' + tmpClass + '">' + tmpTime + tmpBody + tmpChips + '</div>';
		}

		this.pict.views.Layout.openDetail('Subagent: ' + tmpAgent.AgentType, tmpHTML);
	}
}

module.exports = PictViewAgentDetail;
module.exports.default_configuration = _ViewConfiguration;
